"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNotNullOrUndefined = void 0;
exports.isNotNullOrUndefined = function (input) {
  return input !== null && input !== undefined;
};